import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UIEventCustom } from '@app/_utils/ui-event-util';
import { SiteBannerService } from '../_services/site-banner.service';
import { BaseParentComponent } from '@components/_base/base-parent/base-parent.component';
import { TranslateService } from '@ngx-translate/core';
import { displayError } from '@app/_utils/error-util';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-site-banner-management',
  templateUrl: './site-banner-management.component.html',
  styleUrls: ['./site-banner-management.component.css']
})
export class SiteBannerManagementComponent extends BaseParentComponent implements OnInit {

  bannerId: number | null = null;
  fileURL = '';
  imageUrl: string | ArrayBuffer | null = null;
  invalidFileType = false;
  listBannerPageUrl = '/list-site-banner-management';

  addEditForm = this.formBuilder.group({
    id: '',
    filePath: '',
    file: [null, Validators.required],
  });

  constructor(
    private formBuilder:        FormBuilder,
    private route:              ActivatedRoute,
    protected router:           Router,
    private uiEvent:            UIEventCustom,
    private siteBannerService:  SiteBannerService,
  ) {
    super(router);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.bannerId = +params['id'];
        this.loadBannerDetails(this.bannerId);
      }
    });
  }

  private loadBannerDetails(id: number) {
    this.siteBannerService.findById(id).subscribe({
      next: (banner) => {
        this.addEditForm.patchValue(banner);
        this.fileURL = banner.filePath || '';
      },
      error: (err) => {
        displayError(err);
        this.uiEvent.displayUIError();
      }
    });
  }

  onSubmit() {
    if (!this.addEditForm.valid) {
      this.uiEvent.displayUIError();
      return;
    }

    const model = this.constructModel();
    if (this.bannerId) {
      this.sendUpdateRequest(model);
    } else {
      this.sendSaveRequest(model);
    }
  }

  private sendSaveRequest(model: any) {
    this.siteBannerService.save(model).subscribe({
      next: (id) => {
        this.uiEvent.displayUISuccess();
        this.router.navigate([this.listBannerPageUrl]);
      },
      error: (err) => displayError(err)
    });
  }

  private sendUpdateRequest(model: any) {
    this.siteBannerService.update(this.bannerId!, model).subscribe({
      next: () => {
        this.uiEvent.displayUISuccess();
        this.router.navigate([this.listBannerPageUrl]);
      },
      error: (err) => displayError(err)
    });
  }

  private constructModel() {
    const formResult = this.addEditForm.value;
    const { file, ...resultWithoutFile } = formResult;
    resultWithoutFile.filePath = this.fileURL;
    return resultWithoutFile;
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    this.getImageDataUrl(file);
    if (!this.validateFileType(file)) return;
    this.upload(file);
  }

  private validateFileType(file: File): boolean {
    const allowedExtensions = /(\.png|\.jpg|\.jpeg|\.gif|\.svg)$/i;
    if (!allowedExtensions.exec(file.name)) {
      this.invalidFileType = true;
      return false;
    }
    this.invalidFileType = false;
    return true;
  }

  getImageDataUrl(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => (this.imageUrl = e.target.result);
    reader.readAsDataURL(file);
  }

  private upload(file: File) {
    this.siteBannerService.uploadImage(file).subscribe({
      next: (res) => {
        this.fileURL = res;
      },
      error: (err) => displayError(err)
    });
  }

  get mainForm() {
    return this.addEditForm.controls;
  }

}
